// components/PeriodPicker.tsx
import React from 'react';
import { Button } from '@/components/ui/button';
import {
    Select, SelectTrigger, SelectContent, SelectItem, SelectValue
} from '@/components/ui/select';

type Period = 'day'|'week'|'month'|'quarter'|'year'|'all';

const OPTIONS: { value: Period; label: string }[] = [
    { value: 'day', label: 'روز' },
    { value: 'week', label: 'هفته' },
    { value: 'month', label: 'ماه' },
    { value: 'quarter', label: 'فصل' },
    { value: 'year', label: 'سال' },
    { value: 'all', label: 'همه' },
];

export default function PeriodPicker({
                                         value, onChange, disabled = false,
                                     }: { value: Period; onChange: (v: Period)=>void; disabled?: boolean }) {
    return (
        <div className="w-full md:w-auto">
            {/* موبایل/تبلت: دراپ‌داون */}
            <div className="md:hidden">
                <Select value={value} onValueChange={(v)=>onChange(v as Period)} disabled={disabled}>
                    <SelectTrigger className="w-full border-green-300 text-green-700">
                        <SelectValue placeholder="بازه را انتخاب کنید" />
                    </SelectTrigger>
                    <SelectContent>
                        {OPTIONS.map(o => (
                            <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            {/* دسکتاپ: دکمه‌های گروهی با wrap */}
            <div className="hidden md:flex flex-wrap gap-2">
                {OPTIONS.map(o => (
                    <Button
                        key={o.value}
                        size="sm"
                        disabled={disabled}
                        onClick={()=>onChange(o.value)}
                        variant={value === o.value ? 'default' : 'outline'}
                        className={value === o.value ? 'bg-green-600 text-white' : 'border-green-300 text-green-700'}
                    >
                        {o.label}
                    </Button>
                ))}
            </div>
        </div>
    );
}
